/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ acreage: NonNullable<unknown> }} Area_Map_AcreageInputs */

const vi_area_map_acreage = /** @type {(inputs: Area_Map_AcreageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Diện tích: ${i?.acreage} m²`)
};

/**

* @param {Area_Map_AcreageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const area_map_acreage = /** @type {((inputs: Area_Map_AcreageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Area_Map_AcreageInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_area_map_acreage(inputs)
});